import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import Switch from '../../../../../../FormComponents/Switch'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'

export default observer(function KsaSwitch({ action }) {
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)

  const toggleKsa = (event) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { ksa_tax_enabled: event.target.checked } })
    .then(updatedAction => {
      action.ksa_tax_enabled = updatedAction.ksa_tax_enabled
      toastSuccess(updatedAction.ksa_tax_enabled ? 'Ksa enabled' : 'Ksa disabled')
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <Switch name="ksa_tax_enabled" value={action.ksa_tax_enabled} onChange={toggleKsa}/>
  )
})